import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70" role="contentinfo">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-[40%]">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-semibold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>韩漫画网</span>
            </div>
            <h4 className="text-2xl font-bold text-foreground-950 mb-1" style={{ fontFamily: "var(--font-heading)" }}>
              韩漫大全下拉式免费
            </h4>
            <h4 className="text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              无删减韩漫下拉式在线
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md">
              韩漫画网致力于提供最优质的韩漫阅读体验。下拉式阅读、无删减内容、极速更新，让每一位韩漫爱好者都能享受最纯粹的漫画乐趣。
            </p>
            <div className="space-y-3">
              <label className="text-xs font-semibold text-foreground-700 uppercase tracking-wide">订阅更新通知</label>
              <div className="flex flex-col sm:flex-row gap-2 max-w-sm">
                <input
                  type="email"
                  placeholder="输入您的邮箱"
                  className="flex-1 bg-transparent border-b border-background-300 px-2 py-2 text-sm text-foreground-950 placeholder-foreground-600 outline-none focus:border-primary-500 transition-colors"
                />
                <button className="px-6 py-2 border border-background-300 rounded-full text-sm font-medium text-foreground-700 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer">
                  订阅
                </button>
              </div>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <h5 className="text-sm font-semibold text-foreground-950 mb-5">快速链接</h5>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                <a href="#featured" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">热门推荐</a>
                <a href="#latest" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">最新更新</a>
              </div>
            </div>
            <div>
              <h5 className="text-sm font-semibold text-foreground-950 mb-5">漫画分类</h5>
              <div className="flex flex-col gap-3">
                {categories.slice(0, 5).map((cat) => (
                  <Link key={cat.slug} to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h5 className="text-sm font-semibold text-foreground-950 mb-5">联系我们</h5>
              <div className="flex flex-col gap-3 text-sm text-foreground-600">
                <p>邮箱：hello@xxjiaxiang.com</p>
                <p>合作：hello@xxjiaxiang.com</p>
                <div className="flex items-center gap-4 mt-2">
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-base text-foreground-700"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-base text-foreground-700"></i>
                  </a>
                  <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="QQ">
                    <i className="ri-qq-line text-base text-foreground-700"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 韩漫画网 xxjiaxiang.com.com - 韩漫大全下拉式免费阅读，无删减韩漫下拉式在线
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}